import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

const BASE_URL = 'https://app.tryggbo.com';

/**
 * Component that sets the canonical URL for the current page.
 * Uses pathname only - excludes query params and hashes.
 * Place this inside any route to automatically set canonical.
 */
export function CanonicalUrl() {
  const { pathname } = useLocation();
  
  // Build canonical URL: base + pathname only (no query params or hash)
  const canonicalUrl = `${BASE_URL}${pathname}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
